/**
 * クラス名：ヘッダー画面
 * 説明：システムのヘッダー画面である。
 * 作成者：ナンス
 * 作成日：2023/03/01
 * バージョン：1.0
 */
import {
  Card,
  Image,
  Space,
  Tooltip,
  Typography,
  Row,
  Col,
  Button,
  Checkbox,
  Select,
  Input,
  Radio,
  DatePicker,
  Spin,
} from 'antd';
import React, { forwardRef, useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';

import logo from '../assets/images/logo.ico';
import user from '../assets/images/user.png';
import company from '../assets/images/company.png';
import usersetting from '../assets/images/usersetting.png';
import {
  createPartnerCompanySetting,
  getCompanyInfo,
  getMaterialTypeInfo,
  getPartnerCompanySetting,
  getProcessInfo,
  getProcessPatternInfo,
  logOutSubmit,
  updatePartnerCompanySetting,
} from '../views/common/CommonAPI';
import logout from '../assets/images/logout.png';
import {
  CaretDownFilled,
  DownCircleFilled,
  MinusCircleFilled,
  MinusCircleOutlined,
  MinusOutlined,
  PlusCircleFilled,
  PlusCircleOutlined,
  PlusOutlined,
  SettingOutlined,
} from '@ant-design/icons';
import { commonFooter, commonFooterOK, commonModal, commonResponsiveModal } from '../views/common/CommonModal';
import {
  DeliveryArea,
  DiffList,
  diffList,
  InstallationParts,
  MaxBendingLen,
  OneOrderTypes,
  Painting,
  Plating,
  ProcessDateRange,
  RepeatOrderTypes,
  TapForm,
  UsedPlace,
  WeldFinish,
  WeldPartCount,
} from '../views/common/RealGoku_Order_Setting';
import { ServiceClass, WorkType, WorkTypeGroup } from '../views/common/enums';
import { LOT_ORDER, MONTHLY_ORDER, ONE_ORDER } from '../views/common/Constant';
const RadioGroup = Radio.Group;
const Header = (props, ref) => {
  const [loginUser, setLoginUser] = useState();
  const [openRealGokuSetting, setOpenRealGokuSetting] = useState(false);
  const [materialClassData, setMaterialClassData] = useState([]);
  const [oneOrderInfo, setOneOrderInfo] = useState({});
  const [repeatOrderInfo, setRepeatOrderInfo] = useState({});
  const [oldOneOrderInfo, setOldOneOrderInfo] = useState({});
  const [oldRepeatOrderInfo, setOldRepeatOrderInfo] = useState({});
  const [processPatternList, setProcessPatternList] = useState([]);
  const [OneOrderTypesCoeffData, setOneOrderTypesCoeffData] = useState([]);
  const [toleranceCoeffData, setToleranceCoeffData] = useState([]);
  const [weldFinishLevelCoeffData, setWeldFinishLevelCoeffData] = useState([]);
  const [finalPurposCoeffData, setFinalPurposCoeffData] = useState([]);
  const [coeffDeliveryDates, setCoeffDeliveryDates] = useState([]);
  const [plating, setPlating] = useState([]);
  const [painting, setPainting] = useState([]);
  const [openRealGokuSettingLoading, setOpenRealGokuSettingLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    setLoginUser(JSON.parse(decodeURI(localStorage?.getItem('iQxWeb_LoginUser'))));
  }, []);

  const showSetting = () => {
    navigate('/home/:userSetting');
  };

  const prepareDefaultChkInfo = (list, obj, patternLst = []) => {
    let data = {};
    const maxNo = list.reduce((max, item) => (item.no > max ? item.no : max), 0);
    if (patternLst?.length > 0) {
      // 利用箇所用
      data = {
        no: maxNo + 1,
        id: obj.id,
        name: obj.name,
        patternId: patternLst[0]?.id,
        isUsed: false,
      };
    } else {
      data = {
        no: maxNo + 1,
        id: obj.id,
        name: obj.name,
        isUsed: false,
      };
    }
    return data;
  };

  const prepareDefaultChkInfoHyomen = (list, obj) => {
    const maxNo = list.reduce((max, item) => (item.no > max ? item.no : max), 0);
    const data = {
      no: maxNo + 1,
      id: obj.id,
      name: obj.name,
      isUsed: false,
      supportFrom: dayjs().format(),
      supportTo: dayjs().format(),
    };
    return data;
  };

  const prepareDefaultChkInfoMaterial = (list, obj) => {
    const maxNo = list.reduce((max, item) => (item.no > max ? item.no : max), 0);
    const data = {
      no: maxNo + 1,
      materialTypeId: obj.id,
      thicknessFrom: 0,
      thicknessTo: 0,
      isUsed: false,
    };
    return data;
  };

  const prepareDefaultChkInfoMaterialAmt = (list, obj) => {
    const maxNo = list.reduce((max, item) => (item.no > max ? item.no : max), 0);
    const data = {
      no: maxNo + 1,
      materialTypeId: obj.id,
      amt: 0,
      isUsed: false,
    };
    return data;
  };

  const prepareDefaultChkInfoInstallationParts = (list, obj) => {
    const maxNo = list.reduce((max, item) => (item.no > max ? item.no : max), 0);
    const data = {
      no: maxNo + 1,
      id: obj.id,
      name: obj.name,
      materials: [],
      isUsed: false,
    };
    return data;
  };

  //　ログアウトボタンの押下
  const handleClick = async (e) => {
    e.preventDefault();
    const result = await logOutSubmit();
    if (result) {
      navigate('/login');
    }
  };

  const prepareDefaultSetting = () => {
    let newOrderSetting = {
      isSupport: false,
      orderType: [],
      quantityFrom: 1,
      quantityTo: 0,
      materialTypeList: [],
      diff: [],
      weldFinish: [],
      usedPlace: [],
      deliveryDate: [],
      weldPartCount: [],
      installationParts: [],
      installationPartsMaterials: [],
      tapForm: [],
      maxBendingLen: [],
      maxX: 0,
      maxY: 0,
      maxZ: 0,
      deliveryArea: [],
      platingProcess: [],
      paintingProcess: [],
      maxCostUnitPrice: 0,
      maxMaterialCostUnitRate: 0,
      maxWeldCostUnitRate: 0,
      maxWeldFinishCostUnitRate: 0,
    };
    return newOrderSetting;
  };

  const openRealGokuSettingDialog = async (e) => {
    setOpenRealGokuSettingLoading(true);
    setOpenRealGokuSetting(true);
    const materialTypeData = await getMaterialTypeInfo();
    setMaterialClassData(materialTypeData);
    let patternInfos = await getProcessPatternInfo(0, 0, ServiceClass.SheetMetal, 'ASC', 'id');
    let patternLst = [];
    if (patternInfos) {
      patternLst = patternInfos ? patternInfos?.data : [];
      setProcessPatternList(patternLst);
    }
    let tempData = await getCompanyInfo();
    let coeffTolerance =
      tempData?.length > 0 ? tempData[0]?.coeffTolerance?.filter((item) => !item.isDeleted && item.isUsed) : [];
    setToleranceCoeffData(coeffTolerance);

    let coeffWeldFinishLevel =
      tempData?.length > 0 ? tempData[0]?.coeffWeldFinishLevel?.filter((item) => !item.isDeleted && item.isUsed) : [];
    setWeldFinishLevelCoeffData(coeffWeldFinishLevel);

    let coeffFinalPurpose =
      tempData?.length > 0 ? tempData[0]?.coeffFinalPurpose?.filter((item) => !item.isDeleted && item.isUsed) : [];
    setFinalPurposCoeffData(coeffFinalPurpose);

    let coeffDeliveryDates =
      tempData?.length > 0 ? tempData[0]?.coeffDeliveryDates?.filter((item) => !item.isDeleted && item.isUsed) : [];
    setCoeffDeliveryDates(coeffDeliveryDates);

    const kouteiMasterDataDB = await getProcessInfo();
    let processMst = kouteiMasterDataDB?.filter(
      (i) => !i.isDeleted && i.info.isUsed && i.class === ServiceClass.SheetMetal && i.workType === WorkType.SmSurface
    );
    let plating = processMst?.[0]?.details?.processDetailTypes?.filter(
      (i) => i.group === WorkTypeGroup.SmPlating && i.isUsed
    );
    setPlating(plating);
    let painting = processMst?.[0]?.details?.processDetailTypes?.filter(
      (i) => i.group === WorkTypeGroup.SmCoating && i.isUsed
    );
    setPainting(painting);

    let partnerCompSetting = await getPartnerCompanySetting();
    if (partnerCompSetting) {
      let firstOrder = partnerCompSetting?.firstOrder;
      setOneOrderInfo(Object.keys(firstOrder)?.length > 0 ? JSON.parse(JSON.stringify(firstOrder)) : {});
      let repeatOrder = partnerCompSetting?.repeatOrder;
      setRepeatOrderInfo(Object.keys(repeatOrder)?.length > 0 ? JSON.parse(JSON.stringify(repeatOrder)) : {});
      setOpenRealGokuSettingLoading(false);
    } else {
      // 初期状態の場合
      let firstOrder = prepareDefaultSetting();
      setOneOrderInfo(Object.keys(firstOrder)?.length > 0 ? JSON.parse(JSON.stringify(firstOrder)) : {});
      // 初期状態の場合
      let repeatOrder = prepareDefaultSetting();
      setRepeatOrderInfo(Object.keys(repeatOrder)?.length > 0 ? JSON.parse(JSON.stringify(repeatOrder)) : {});
      setOpenRealGokuSettingLoading(false);
    }
  };

  const settingOk = async (e) => {
    let upOneOrderInfo = oneOrderInfo;
    let upRepeatOrderInfo = repeatOrderInfo;
    // 旧パラ情報削除
    // 公差
    let validToleranceCoeffData = upOneOrderInfo?.diff?.filter((b) => toleranceCoeffData?.some((a) => a.id === b.id));
    upOneOrderInfo.diff = validToleranceCoeffData;
    validToleranceCoeffData = upRepeatOrderInfo?.diff?.filter((b) => toleranceCoeffData?.some((a) => a.id === b.id));
    upRepeatOrderInfo.diff = validToleranceCoeffData;
    // 仕上
    let validWeldFinishData = upOneOrderInfo?.weldFinish?.filter((b) =>
      weldFinishLevelCoeffData?.some((a) => a.id === b.id)
    );
    upOneOrderInfo.weldFinish = validWeldFinishData;
    validWeldFinishData = upRepeatOrderInfo?.weldFinish?.filter((b) =>
      weldFinishLevelCoeffData?.some((a) => a.id === b.id)
    );
    upRepeatOrderInfo.weldFinish = validWeldFinishData;
    // 利用箇所
    let validUsedPlace = upOneOrderInfo?.usedPlace?.filter((b) => finalPurposCoeffData?.some((a) => a.id === b.id));
    upOneOrderInfo.usedPlace = validUsedPlace;
    validUsedPlace = upRepeatOrderInfo?.usedPlace?.filter((b) => finalPurposCoeffData?.some((a) => a.id === b.id));
    upRepeatOrderInfo.usedPlace = validUsedPlace;
    // 対応納期
    let validDeliveryDate = upOneOrderInfo?.deliveryDate?.filter((b) => coeffDeliveryDates?.some((a) => a.id === b.id));
    upOneOrderInfo.deliveryDate = validDeliveryDate;
    validDeliveryDate = upRepeatOrderInfo?.deliveryDate?.filter((b) => coeffDeliveryDates?.some((a) => a.id === b.id));
    upRepeatOrderInfo.deliveryDate = validDeliveryDate;
    // メッキ処理
    let validPlatingProcess = upOneOrderInfo?.platingProcess?.filter((b) => plating?.some((a) => a.id === b.id));
    upOneOrderInfo.platingProcess = validPlatingProcess;
    validDeliveryDate = upRepeatOrderInfo?.platingProcess?.filter((b) => plating?.some((a) => a.id === b.id));
    upRepeatOrderInfo.platingProcess = validPlatingProcess;
    // 塗装処理
    let validPaintingProcess = upOneOrderInfo?.paintingProcess?.filter((b) => painting?.some((a) => a.id === b.id));
    upOneOrderInfo.paintingProcess = validPaintingProcess;
    validDeliveryDate = upRepeatOrderInfo?.paintingProcess?.filter((b) => painting?.some((a) => a.id === b.id));
    upRepeatOrderInfo.paintingProcess = validPaintingProcess;

    let addPartnerCompSetting = await updatePartnerCompanySetting(upOneOrderInfo, upRepeatOrderInfo);
    if (addPartnerCompSetting) {
      setOpenRealGokuSetting(false);
    }
  };

  const settingCancel = (e) => {
    setOpenRealGokuSetting(false);
  };

  // 'From'日付に'To'より後の日付を選べないように制限
  const disabledFromDate = (deliveryDateTo) => {
    return (deliveryDateFrom) => {
      if (!deliveryDateTo) {
        return false;
      }
      return deliveryDateFrom && deliveryDateFrom.isAfter(dayjs(deliveryDateTo, 'YYYY-MM-DD'), 'day');
    };
    //return dayjs(current, 'YYYY-MM-DD') && dayjs(current, 'YYYY-MM-DD').isAfter(dayjs(dateTo, 'YYYY-MM-DD'), 'day');
  };

  // 'To'日付の選択制限を行う関数
  const disabledToDate = (deliveryDateFrom) => {
    return (deliveryDateTo) => {
      // 'From'日付以降の日付を選べるようにする
      if (!deliveryDateFrom) {
        return false;
      }
      return deliveryDateTo && deliveryDateTo.isBefore(dayjs(deliveryDateFrom, 'YYYY-MM-DD'), 'day');
    };
  };

  const modalTitle = (
    <div
      style={{
        background: '#005fab',
        color: 'white',
        fontSize: 14,
        borderTopLeftRadius: 7,
        borderTopRightRadius: 7,
        display: 'flex',
        justifyContent: 'left',
        alignItems: 'center',
        height: 36,
        marginLeft: -24,
        marginTop: -20,
        marginRight: -24,
      }}
    >
      <p style={{ marginLeft: 10, paddingTop: 15, paddingLeft: 18, color: 'white' }}>RealGoku受注設定</p>
    </div>
  );

  const commonSettingItem_oneOrder = (
    <div className="real-goku-setting-div-padding">
      <div className="real-goku-setting-div">
        {/** 受注分類 */}
        <Row>
          <Col span={24}>
            <div className="real-goku-setting-item-label-div">
              <label className="real-goku-setting-item-label">受注分類</label>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            {OneOrderTypes?.map((item, index) => (
              <Checkbox
                className="real-goku-setting-item-chk"
                key="unitOrder"
                type="checkbox"
                name={'unitOrder'}
                id={'unitOrder'}
                checked={
                  oneOrderInfo?.orderType?.length > 0
                    ? oneOrderInfo?.orderType?.filter((i) => i.id === item.id)?.[0]?.isUsed
                    : false
                }
                onChange={(e) => {
                  if (oneOrderInfo.orderType) {
                    let upOrderTypeList = [...oneOrderInfo.orderType];
                    let upIndex = upOrderTypeList?.findIndex((opt) => opt.id === item.id);
                    if (upIndex >= 0 && upOrderTypeList?.[upIndex]) {
                      if (e.target.checked) {
                        upOrderTypeList[upIndex].isUsed = e.target.checked;
                      } else {
                        // チェックを外した場合、配列から削除する
                        upOrderTypeList = upOrderTypeList?.filter((i) => i.id !== item.id);
                      }
                    } else {
                      let newOrderType = prepareDefaultChkInfo(upOrderTypeList, item);
                      if (newOrderType) {
                        newOrderType.isUsed = e.target.checked;
                        upOrderTypeList.push(newOrderType);
                      }
                    }
                    setOneOrderInfo({
                      ...oneOrderInfo,
                      orderType: upOrderTypeList,
                    });
                  }
                }}
              >
                {item?.name}
              </Checkbox>
            ))}
          </Col>
        </Row>
        {/** 個数 */}
        <Row className="real-goku-setting-item-row">
          <Col span={24}>
            <div className="real-goku-setting-item-label-div">
              <label className="real-goku-setting-item-label">個数</label>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            （
            <Input
              className="real-goku-setting-item-input"
              value={oneOrderInfo.quantityFrom}
              onChange={(e) => {
                if (/^\d*$/.test(e.target.value)) {
                  setOneOrderInfo({
                    ...oneOrderInfo,
                    quantityFrom: e.target.value,
                  });
                }
              }}
            ></Input>
            ）個～（
            <Input
              className="real-goku-setting-item-input "
              value={oneOrderInfo.quantityTo}
              onChange={(e) => {
                if (/^\d*$/.test(e.target.value)) {
                  setOneOrderInfo({
                    ...oneOrderInfo,
                    quantityTo: e.target.value,
                  });
                }
              }}
            ></Input>
            ）個
          </Col>
        </Row>
        {/** 単価上限 */}
        <Row className="real-goku-setting-item-row">
          <Col span={24}>
            <div className="real-goku-setting-item-label-div">
              <label className="real-goku-setting-item-label">単価上限</label>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <div className="real-goku-setting-item-chk">
              ～
              <Input
                className="real-goku-setting-item-input"
                style={{ width: 100 }}
                value={oneOrderInfo.maxCostUnitPrice}
                onChange={(e) => {
                  if (/^\d*$/.test(e.target.value)) {
                    setOneOrderInfo({
                      ...oneOrderInfo,
                      maxCostUnitPrice: e.target.value,
                    });
                  }
                }}
              ></Input>
              円/個
            </div>
          </Col>
        </Row>
        {/** 材料・製造原価の合計の内訳に対して */}
        <Row className="real-goku-setting-item-row">
          <Col span={24}>
            <div className="real-goku-setting-item-label-div" style={{ width: 300 }}>
              <label className="real-goku-setting-item-label">材料・製造原価の合計の内訳に対して</label>
            </div>
          </Col>
        </Row>
        {/** 材料上限 */}
        <Row>
          <Col span={24}>
            <div className="real-goku-setting-item-chk">
              材料上限（
              <Input
                className="real-goku-setting-item-input"
                value={oneOrderInfo.maxMaterialCostUnitRate}
                onChange={(e) => {
                  if (/^\d*$/.test(e.target.value)) {
                    setOneOrderInfo({
                      ...oneOrderInfo,
                      maxMaterialCostUnitRate: e.target.value,
                    });
                  }
                }}
              ></Input>
              ）％になったら自動算出しない
            </div>
          </Col>
        </Row>
        {/** 溶接上限 */}
        <Row>
          <Col span={24}>
            <div className="real-goku-setting-item-chk">
              溶接上限（
              <Input
                className="real-goku-setting-item-input"
                value={oneOrderInfo.maxWeldCostUnitRate}
                onChange={(e) => {
                  if (/^\d*$/.test(e.target.value)) {
                    setOneOrderInfo({
                      ...oneOrderInfo,
                      maxWeldCostUnitRate: e.target.value,
                    });
                  }
                }}
              ></Input>
              ）％になったら自動算出しない
            </div>
          </Col>
        </Row>
        {/** 仕上上限 */}
        <Row>
          <Col span={24}>
            <div className="real-goku-setting-item-chk">
              仕上上限（
              <Input
                className="real-goku-setting-item-input"
                value={oneOrderInfo.maxWeldFinishCostUnitRate}
                onChange={(e) => {
                  if (/^\d*$/.test(e.target.value)) {
                    setOneOrderInfo({
                      ...oneOrderInfo,
                      maxWeldFinishCostUnitRate: e.target.value,
                    });
                  }
                }}
              ></Input>
              ）％になったら自動算出しない
            </div>
          </Col>
        </Row>
        {/** 材質・板厚 */}
        <Row className="real-goku-setting-item-row">
          <Col span={24}>
            <div className="real-goku-setting-item-label-div">
              <label className="real-goku-setting-item-label">材質・板厚</label>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            {materialClassData?.map((materialType, index) => (
              <div>
                <Checkbox
                  className="real-goku-setting-item-chk real-goku-setting-item-chk-date-width"
                  key={'materialTypeList' + index}
                  type="checkbox"
                  name={'materialTypeList' + index}
                  id={'materialTypeList' + index}
                  checked={
                    oneOrderInfo?.materialTypeList?.length > 0
                      ? oneOrderInfo?.materialTypeList?.filter((i) => i.materialTypeId === materialType.id)?.[0]?.isUsed
                      : false
                  }
                  onChange={(e) => {
                    let upMaterialTypeList = [...oneOrderInfo.materialTypeList];
                    let upIndex = upMaterialTypeList?.findIndex((opt) => opt.materialTypeId === materialType.id);
                    if (upIndex >= 0 && upMaterialTypeList?.[upIndex]) {
                      if (e.target.checked) {
                        upMaterialTypeList[upIndex].isUsed = e.target.checked;
                      } else {
                        // チェックを外した場合、配列から削除する
                        upMaterialTypeList = upMaterialTypeList?.filter((i) => i.materialTypeId !== materialType.id);
                      }
                    } else {
                      let newMaterialType = prepareDefaultChkInfoMaterial(upMaterialTypeList, materialType);
                      if (newMaterialType) {
                        newMaterialType.isUsed = e.target.checked;
                        upMaterialTypeList.push(newMaterialType);
                      }
                    }
                    setOneOrderInfo({
                      ...oneOrderInfo,
                      materialTypeList: upMaterialTypeList,
                    });
                  }}
                >
                  <Typography.Text id={'typographyTxt'} ellipsis={{ tooltip: [materialType.name] }}>
                    {materialType.name}
                  </Typography.Text>
                </Checkbox>
                <label className="real-goku-setting-item-label">（</label>
                <Input
                  disabled={
                    oneOrderInfo?.materialTypeList?.length > 0
                      ? oneOrderInfo?.materialTypeList?.filter((i) => i.materialTypeId === materialType.id)?.[0]?.isUsed
                        ? false
                        : true
                      : true
                  }
                  className="real-goku-setting-item-input "
                  value={
                    oneOrderInfo?.materialTypeList?.length > 0
                      ? oneOrderInfo?.materialTypeList?.filter((i) => i.materialTypeId === materialType.id)?.[0]
                          ?.thicknessFrom
                      : ''
                  }
                  onChange={(e) => {
                    if (/^\d*\.?\d*$/.test(e.target.value)) {
                      let upMaterialTypeList = [...oneOrderInfo?.materialTypeList];
                      let upIndex = upMaterialTypeList?.findIndex((opt) => opt.materialTypeId === materialType.id);
                      if (upIndex >= 0 && upMaterialTypeList?.[upIndex]) {
                        upMaterialTypeList[upIndex].thicknessFrom = e.target.value;
                      }
                      setOneOrderInfo({
                        ...oneOrderInfo,
                        materialTypeList: upMaterialTypeList,
                      });
                    }
                  }}
                ></Input>
                <label className="real-goku-setting-item-label">）mm～（</label>
                <Input
                  disabled={
                    oneOrderInfo?.materialTypeList?.length > 0
                      ? oneOrderInfo?.materialTypeList?.filter((i) => i.materialTypeId === materialType.id)?.[0]?.isUsed
                        ? false
                        : true
                      : true
                  }
                  className="real-goku-setting-item-input "
                  value={
                    oneOrderInfo?.materialTypeList?.length > 0
                      ? oneOrderInfo?.materialTypeList?.filter((i) => i.materialTypeId === materialType.id)?.[0]
                          ?.thicknessTo
                      : ''
                  }
                  onChange={(e) => {
                    if (/^\d*\.?\d*$/.test(e.target.value)) {
                      let upMaterialTypeList = [...oneOrderInfo?.materialTypeList];
                      let upIndex = upMaterialTypeList?.findIndex((opt) => opt.materialTypeId === materialType.id);
                      if (upIndex >= 0 && upMaterialTypeList?.[upIndex]) {
                        upMaterialTypeList[upIndex].thicknessTo = e.target.value;
                      }
                      setOneOrderInfo({
                        ...oneOrderInfo,
                        materialTypeList: upMaterialTypeList,
                      });
                    }
                  }}
                ></Input>
                <label className="real-goku-setting-item-label">）mm</label>
              </div>
            ))}
          </Col>
        </Row>
        {/** 公差 */}
        <Row className="real-goku-setting-item-row">
          <Col span={24}>
            <div className="real-goku-setting-item-label-div">
              <label className="real-goku-setting-item-label">公差</label>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <div>
              {toleranceCoeffData?.map((item, index) => (
                <>
                  <Checkbox
                    className="real-goku-setting-item-chk real-goku-setting-item-chk-date-width"
                    key={'diff' + index}
                    type="checkbox"
                    name={'diff' + index}
                    id={'diff' + index}
                    checked={
                      oneOrderInfo?.diff?.length > 0
                        ? oneOrderInfo?.diff?.filter((i) => i.id === item.id)?.[0]?.isUsed
                        : false
                    }
                    onChange={(e) => {
                      if (oneOrderInfo.diff) {
                        let upDiff = [...oneOrderInfo.diff];
                        let upIndex = upDiff?.findIndex((opt) => opt.id === item.id);
                        if (upIndex >= 0 && upDiff?.[upIndex]) {
                          if (e.target.checked) {
                            upDiff[upIndex].isUsed = e.target.checked;
                          } else {
                            // チェックを外した場合、配列から削除する
                            upDiff = upDiff?.filter((i) => i.id !== item.id);
                          }
                        } else {
                          let newDiff = prepareDefaultChkInfo(upDiff, item);
                          if (newDiff) {
                            newDiff.isUsed = e.target.checked;
                            upDiff.push(newDiff);
                          }
                        }
                        setOneOrderInfo({
                          ...oneOrderInfo,
                          diff: upDiff,
                        });
                      }
                    }}
                  >
                    <Typography.Text id={'typographyTxt'} ellipsis={{ tooltip: [item.name] }}>
                      {item.name}
                    </Typography.Text>
                  </Checkbox>
                  {/* 4個ごとに改行 */}
                  {(index + 1) % 4 === 0 && <br />}
                </>
              ))}
            </div>
          </Col>
        </Row>
        {/** 仕上 */}
        <Row className="real-goku-setting-item-row">
          <Col span={24}>
            <div className="real-goku-setting-item-label-div">
              <label className="real-goku-setting-item-label">仕上</label>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            {weldFinishLevelCoeffData?.map((weldFinish, index) => (
              <>
                <Checkbox
                  className="real-goku-setting-item-chk real-goku-setting-item-chk-date-width"
                  key={'weldFinish' + index}
                  type="checkbox"
                  name={'weldFinish' + index}
                  id={'weldFinish' + index}
                  checked={
                    oneOrderInfo?.weldFinish?.length > 0
                      ? oneOrderInfo?.weldFinish?.filter((i) => i.id === weldFinish.id)?.[0]?.isUsed
                      : false
                  }
                  onChange={(e) => {
                    if (oneOrderInfo.weldFinish) {
                      let upWeldFinish = [...oneOrderInfo.weldFinish];
                      let upIndex = upWeldFinish?.findIndex((opt) => opt.id === weldFinish.id);
                      if (upIndex >= 0 && upWeldFinish?.[upIndex]) {
                        if (e.target.checked) {
                          upWeldFinish[upIndex].isUsed = e.target.checked;
                        } else {
                          // チェックを外した場合、配列から削除する
                          upWeldFinish = upWeldFinish?.filter((i) => i.id !== weldFinish.id);
                        }
                      } else {
                        let newWeldFinish = prepareDefaultChkInfoHyomen(upWeldFinish, weldFinish);
                        if (newWeldFinish) {
                          newWeldFinish.isUsed = e.target.checked;
                          upWeldFinish.push(newWeldFinish);
                        }
                      }
                      setOneOrderInfo({
                        ...oneOrderInfo,
                        weldFinish: upWeldFinish,
                      });
                    }
                  }}
                >
                  <Typography.Text id={'typographyTxt'} ellipsis={{ tooltip: [weldFinish.name] }}>
                    {weldFinish.name}
                  </Typography.Text>
                </Checkbox>
                {/* 4個ごとに改行 */}
                {(index + 1) % 4 === 0 && <br />}
              </>
            ))}
          </Col>
        </Row>
        {/** 利用箇所 */}
        <Row className="real-goku-setting-item-row">
          <Col span={24}>
            <div className="real-goku-setting-item-label-div">
              <label className="real-goku-setting-item-label">利用箇所</label>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            {finalPurposCoeffData?.map((used, index) => (
              <Row>
                <Col span={8}>
                  <Checkbox
                    className="real-goku-setting-item-chk"
                    key={'usedPlace' + index}
                    type="checkbox"
                    name={'usedPlace' + index}
                    id={'usedPlace' + index}
                    checked={
                      oneOrderInfo?.usedPlace?.length > 0
                        ? oneOrderInfo?.usedPlace?.filter((i) => i.id === used.id)?.[0]?.isUsed
                        : false
                    }
                    onChange={(e) => {
                      if (oneOrderInfo.usedPlace) {
                        let upUsedPlace = [...oneOrderInfo.usedPlace];
                        let upIndex = upUsedPlace?.findIndex((opt) => opt.id === used.id);
                        if (upIndex >= 0 && upUsedPlace?.[upIndex]) {
                          if (e.target.checked) {
                            upUsedPlace[upIndex].isUsed = e.target.checked;
                          } else {
                            // チェックを外した場合、配列から削除する
                            upUsedPlace = upUsedPlace?.filter((i) => i.id !== used.id);
                          }
                        } else {
                          let newUsedPlace = prepareDefaultChkInfo(upUsedPlace, used, processPatternList);
                          if (newUsedPlace) {
                            newUsedPlace.isUsed = e.target.checked;
                            upUsedPlace.push(newUsedPlace);
                          }
                        }
                        setOneOrderInfo({
                          ...oneOrderInfo,
                          usedPlace: upUsedPlace,
                        });
                      }
                    }}
                  >
                    <Typography.Text id={'typographyTxt'} ellipsis={{ tooltip: [used.name] }}>
                      {used.name}
                    </Typography.Text>
                  </Checkbox>
                </Col>
                <Col span={6}>
                  <label>⇒引当工程パターン</label>
                </Col>
                <Col span={8}>
                  <Select
                    className="real-goku-material-type-select-pattern "
                    onChange={(e) => {
                      let upUsedPlace = [...oneOrderInfo.usedPlace];
                      let upIndex = upUsedPlace?.findIndex((opt) => opt.id === used.id);
                      if (upIndex >= 0 && upUsedPlace?.[upIndex]) {
                        upUsedPlace[upIndex].patternId = e;
                      }
                      setOneOrderInfo({
                        ...oneOrderInfo,
                        usedPlace: upUsedPlace,
                      });
                    }}
                    id={'process-pattern'}
                    name={'process-pattern'}
                    value={
                      oneOrderInfo?.usedPlace?.filter((i) => i.id === used.id)?.[0]?.patternId !== undefined
                        ? oneOrderInfo?.usedPlace?.filter((i) => i.id === used.id)?.[0]?.patternId
                        : processPatternList?.length > 0
                        ? processPatternList?.[0]?.id
                        : processPatternList?.length > 0
                        ? processPatternList?.[0]?.id
                        : 0
                    }
                    suffixIcon={<CaretDownFilled style={{ color: '#000000', fontSize: 20 }} />}
                  >
                    {processPatternList?.map((item, index) => (
                      <Select.Option key={index} id={'materialRef' + item.id} value={item.id}>
                        {item.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Col>
              </Row>
            ))}
          </Col>
        </Row>
        {/** 対応納期 */}
        <Row className="real-goku-setting-item-row">
          <Col span={24}>
            <div className="real-goku-setting-item-label-div">
              <label className="real-goku-setting-item-label">対応納期</label>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            {coeffDeliveryDates?.map((dates, index) => (
              <>
                <Checkbox
                  className="real-goku-setting-item-chk real-goku-setting-item-chk-date-width"
                  key={'deliveryDate' + index}
                  type="checkbox"
                  name={'deliveryDate' + index}
                  id={'deliveryDate' + index}
                  checked={
                    oneOrderInfo?.deliveryDate?.length > 0
                      ? oneOrderInfo?.deliveryDate?.filter((i) => i.id === dates.id)?.[0]?.isUsed
                      : false
                  }
                  onChange={(e) => {
                    if (oneOrderInfo.deliveryDate) {
                      let upDeliveryDate = [...oneOrderInfo.deliveryDate];
                      let upIndex = upDeliveryDate?.findIndex((opt) => opt.id === dates.id);
                      if (upIndex >= 0 && upDeliveryDate?.[upIndex]) {
                        if (e.target.checked) {
                          upDeliveryDate[upIndex].isUsed = e.target.checked;
                        } else {
                          // チェックを外した場合、配列から削除する
                          upDeliveryDate = upDeliveryDate?.filter((i) => i.id !== dates.id);
                        }
                      } else {
                        let newDeliveryDate = prepareDefaultChkInfo(upDeliveryDate, dates);
                        if (newDeliveryDate) {
                          newDeliveryDate.isUsed = e.target.checked;
                          upDeliveryDate.push(newDeliveryDate);
                        }
                      }
                      setOneOrderInfo({
                        ...oneOrderInfo,
                        deliveryDate: upDeliveryDate,
                      });
                    }
                  }}
                >
                  <Typography.Text id={'typographyTxt'} ellipsis={{ tooltip: [dates.name] }}>
                    {dates.name}
                  </Typography.Text>
                </Checkbox>
                {/* 4個ごとに改行 */}
                {(index + 1) % 4 === 0 && <br />}
              </>
            ))}
          </Col>
        </Row>
        {/** 溶接部品点数 */}
        <Row className="real-goku-setting-item-row">
          <Col span={24}>
            <div className="real-goku-setting-item-label-div">
              <label className="real-goku-setting-item-label">溶接部品点数</label>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            {WeldPartCount?.map((partCount, index) => (
              <>
                <Checkbox
                  className="real-goku-setting-item-chk real-goku-setting-item-chk-date-width"
                  key={'partCount' + index}
                  type="checkbox"
                  name={'partCount' + index}
                  id={'partCount' + index}
                  checked={
                    oneOrderInfo?.weldPartCount?.length > 0
                      ? oneOrderInfo?.weldPartCount?.filter((i) => i.id === partCount.id)?.[0]?.isUsed
                      : false
                  }
                  onChange={(e) => {
                    if (oneOrderInfo.weldPartCount) {
                      let upWeldPartCount = [...oneOrderInfo.weldPartCount];
                      let upIndex = upWeldPartCount?.findIndex((opt) => opt.id === partCount.id);
                      if (upIndex >= 0 && upWeldPartCount?.[upIndex]) {
                        if (e.target.checked) {
                          upWeldPartCount[upIndex].isUsed = e.target.checked;
                        } else {
                          // チェックを外した場合、配列から削除する
                          upWeldPartCount = upWeldPartCount?.filter((i) => i.id !== partCount.id);
                        }
                      } else {
                        let newWeldPartCount = prepareDefaultChkInfo(upWeldPartCount, partCount);
                        if (newWeldPartCount) {
                          newWeldPartCount.isUsed = e.target.checked;
                          upWeldPartCount.push(newWeldPartCount);
                        }
                      }
                      setOneOrderInfo({
                        ...oneOrderInfo,
                        weldPartCount: upWeldPartCount,
                      });
                    }
                  }}
                >
                  {partCount.name}
                </Checkbox>
                {/* 4個ごとに改行 */}
                {(index + 1) % 4 === 0 && <br />}
              </>
            ))}
          </Col>
        </Row>
        {/** 取付部品 */}
        <Row className="real-goku-setting-item-row">
          <Col span={24}>
            <div className="real-goku-setting-item-label-div">
              <label className="real-goku-setting-item-label">取付部品</label>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            {InstallationParts?.map((installPart, index) => (
              <>
                <Checkbox
                  className="real-goku-setting-item-chk"
                  key={'installPart' + index}
                  type="checkbox"
                  name={'installPart' + index}
                  id={'installPart' + index}
                  checked={
                    oneOrderInfo?.installationParts?.length > 0
                      ? oneOrderInfo?.installationParts?.filter((i) => i.id === installPart.id)?.[0]?.isUsed
                      : false
                  }
                  onChange={(e) => {
                    if (oneOrderInfo.installationParts) {
                      let upInstallationParts = [...oneOrderInfo.installationParts];
                      let upIndex = upInstallationParts?.findIndex((opt) => opt.id === installPart.id);
                      if (upIndex >= 0 && upInstallationParts?.[upIndex]) {
                        if (e.target.checked) {
                          upInstallationParts[upIndex].isUsed = e.target.checked;
                        } else {
                          // チェックを外した場合、配列から削除する
                          upInstallationParts = upInstallationParts?.filter((i) => i.id !== installPart.id);
                        }
                      } else {
                        let newInstallationParts = prepareDefaultChkInfoInstallationParts(
                          upInstallationParts,
                          installPart
                        );
                        if (newInstallationParts) {
                          newInstallationParts.isUsed = e.target.checked;
                          upInstallationParts.push(newInstallationParts);
                        }
                      }
                      setOneOrderInfo({
                        ...oneOrderInfo,
                        installationParts: upInstallationParts,
                      });
                    }
                  }}
                >
                  {installPart.name}
                </Checkbox>
              </>
            ))}
            <br />
            {materialClassData?.map((material, index) => (
              <div style={{ marginLeft: 10 }}>
                <Checkbox
                  className="real-goku-setting-item-chk real-goku-setting-item-chk-date-width"
                  key={'installationPartsMaterials' + index}
                  type="checkbox"
                  name={'installationPartsMaterials' + index}
                  id={'installationPartsMaterials' + index}
                  checked={
                    oneOrderInfo?.installationPartsMaterials?.length > 0
                      ? oneOrderInfo?.installationPartsMaterials?.filter((i) => i.materialTypeId === material.id)?.[0]
                          ?.isUsed
                      : false
                  }
                  onChange={(e) => {
                    if (oneOrderInfo.installationPartsMaterials) {
                      let upInstallationPartsMaterials = [...oneOrderInfo.installationPartsMaterials];
                      let upIndex = upInstallationPartsMaterials?.findIndex(
                        (opt) => opt.materialTypeId === material.id
                      );
                      if (upIndex >= 0 && upInstallationPartsMaterials[upIndex]) {
                        if (e.target.checked) {
                          upInstallationPartsMaterials[upIndex].isUsed = e.target.checked;
                        } else {
                          // チェックを外した場合、配列から削除する
                          upInstallationPartsMaterials = upInstallationPartsMaterials?.filter(
                            (i) => i.materialTypeId !== material.id
                          );
                        }
                      } else {
                        let newMaterialType = prepareDefaultChkInfoMaterialAmt(upInstallationPartsMaterials, material);
                        if (newMaterialType) {
                          newMaterialType.isUsed = e.target.checked;
                          upInstallationPartsMaterials.push(newMaterialType);
                        }
                      }
                      setOneOrderInfo({
                        ...oneOrderInfo,
                        installationPartsMaterials: upInstallationPartsMaterials,
                      });
                    }
                  }}
                >
                  <Typography.Text id={'typographyTxt'} ellipsis={{ tooltip: [material.name] }}>
                    {material.name}
                  </Typography.Text>
                </Checkbox>
                <label className="real-goku-setting-item-label">（</label>
                <Input
                  disabled={
                    oneOrderInfo.installationPartsMaterials?.length > 0
                      ? oneOrderInfo.installationPartsMaterials?.filter(
                          (opt) => opt.materialTypeId === material.id
                        )?.[0]?.isUsed
                        ? false
                        : true
                      : true
                  }
                  className="real-goku-setting-item-input "
                  style={{ width: 100 }}
                  value={
                    oneOrderInfo.installationPartsMaterials?.length > 0
                      ? oneOrderInfo.installationPartsMaterials?.filter(
                          (opt) => opt.materialTypeId === material.id
                        )?.[0]?.amt
                      : ''
                  }
                  onChange={(e) => {
                    if (/^\d*\.?\d*$/.test(e.target.value)) {
                      if (oneOrderInfo.installationPartsMaterials) {
                        let upInstallationPartsMaterials = [...oneOrderInfo.installationPartsMaterials];
                        let upIndex = upInstallationPartsMaterials?.findIndex(
                          (opt) => opt.materialTypeId === material.id
                        );
                        if (
                          upIndex >= 0 &&
                          upInstallationPartsMaterials[upIndex] &&
                          upInstallationPartsMaterials[upIndex].isUsed
                        ) {
                          upInstallationPartsMaterials[upIndex].amt = e.target.value;
                        }
                        setOneOrderInfo({
                          ...oneOrderInfo,
                          installationPartsMaterials: upInstallationPartsMaterials,
                        });
                      }
                    }
                  }}
                ></Input>
                <label className="real-goku-setting-item-label">）円</label>
              </div>
            ))}
          </Col>
        </Row>
        {/** タップ・成形 */}
        <Row className="real-goku-setting-item-row">
          <Col span={24}>
            <div className="real-goku-setting-item-label-div">
              <label className="real-goku-setting-item-label">タップ・成形</label>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            {TapForm?.map((tap, index) => (
              <Checkbox
                className="real-goku-setting-item-chk real-goku-setting-item-chk-common-width"
                key={'tap' + index}
                type="checkbox"
                name={'tap' + index}
                id={'tap' + index}
                checked={
                  oneOrderInfo?.tapForm?.length > 0
                    ? oneOrderInfo?.tapForm?.filter((i) => i.id === tap.id)?.[0]?.isUsed
                    : false
                }
                onChange={(e) => {
                  if (oneOrderInfo.tapForm) {
                    let upTapForm = [...oneOrderInfo.tapForm];
                    let upIndex = upTapForm?.findIndex((opt) => opt.id === tap.id);
                    if (upIndex >= 0 && upTapForm?.[upIndex]) {
                      if (e.target.checked) {
                        upTapForm[upIndex].isUsed = e.target.checked;
                      } else {
                        // チェックを外した場合、配列から削除する
                        upTapForm = upTapForm?.filter((i) => i.id !== tap.id);
                      }
                    } else {
                      let newTapForm = prepareDefaultChkInfo(upTapForm, tap);
                      if (newTapForm) {
                        newTapForm.isUsed = e.target.checked;
                        upTapForm.push(newTapForm);
                      }
                    }
                    setOneOrderInfo({
                      ...oneOrderInfo,
                      tapForm: upTapForm,
                    });
                  }
                }}
              >
                {tap.name}
              </Checkbox>
            ))}
          </Col>
        </Row>
        {/** 最大曲げ長さ */}
        <Row className="real-goku-setting-item-row">
          <Col span={24}>
            <div className="real-goku-setting-item-label-div">
              <label className="real-goku-setting-item-label">最大曲げ長さ</label>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            {MaxBendingLen?.map((bending, index) => (
              <>
                <Checkbox
                  className="real-goku-setting-item-chk real-goku-setting-item-chk-common-width"
                  key={'bending' + index}
                  type="checkbox"
                  name={'bending' + index}
                  id={'bending' + index}
                  checked={
                    oneOrderInfo?.maxBendingLen?.length > 0
                      ? oneOrderInfo?.maxBendingLen?.filter((i) => i.id === bending.id)?.[0]?.isUsed
                      : false
                  }
                  onChange={(e) => {
                    if (oneOrderInfo.maxBendingLen) {
                      let upMaxBendingLen = [...oneOrderInfo.maxBendingLen];
                      let upIndex = upMaxBendingLen?.findIndex((opt) => opt.id === bending.id);
                      if (upIndex >= 0 && upMaxBendingLen?.[upIndex]) {
                        if (e.target.checked) {
                          upMaxBendingLen[upIndex].isUsed = e.target.checked;
                        } else {
                          // チェックを外した場合、配列から削除する
                          upMaxBendingLen = upMaxBendingLen?.filter((i) => i.id !== bending.id);
                        }
                      } else {
                        let newMaxBendingLen = prepareDefaultChkInfo(upMaxBendingLen, bending);
                        if (newMaxBendingLen) {
                          newMaxBendingLen.isUsed = e.target.checked;
                          upMaxBendingLen.push(newMaxBendingLen);
                        }
                      }
                      setOneOrderInfo({
                        ...oneOrderInfo,
                        maxBendingLen: upMaxBendingLen,
                      });
                    }
                  }}
                >
                  {bending.name}
                </Checkbox>
                {/* 4個ごとに改行 */}
                {(index + 1) % 5 === 0 && <br />}
              </>
            ))}
          </Col>
        </Row>
        {/** 最大サイズ */}
        <Row className="real-goku-setting-item-row">
          <Col span={24}>
            <div className="real-goku-setting-item-label-div">
              <label className="real-goku-setting-item-label">最大サイズ</label>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <div style={{ marginLeft: 15 }}>
              X
              <Input
                className="real-goku-setting-item-input"
                value={oneOrderInfo.maxX}
                onChange={(e) => {
                  if (/^\d*\.?\d*$/.test(e.target.value)) {
                    setOneOrderInfo({
                      ...oneOrderInfo,
                      maxX: e.target.value,
                    });
                  }
                }}
              ></Input>
              ）mm Y（
              <Input
                className="real-goku-setting-item-input"
                value={oneOrderInfo.maxY}
                onChange={(e) => {
                  if (/^\d*\.?\d*$/.test(e.target.value)) {
                    setOneOrderInfo({
                      ...oneOrderInfo,
                      maxY: e.target.value,
                    });
                  }
                }}
              ></Input>
              ）mm Z（
              <Input
                className="real-goku-setting-item-input"
                value={oneOrderInfo.maxZ}
                onChange={(e) => {
                  if (oneOrderInfo.maxZ != e.target.value) {
                    setOneOrderInfo({
                      ...oneOrderInfo,
                      maxZ: e.target.value,
                    });
                  }
                }}
              ></Input>
              ）mm
            </div>
          </Col>
        </Row>
        {/** 納品可能エリア */}
        <Row className="real-goku-setting-item-row">
          <Col span={24}>
            <div className="real-goku-setting-item-label-div">
              <label className="real-goku-setting-item-label">納品可能エリア</label>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            {DeliveryArea?.map((deliveryArea, index) => (
              <>
                <Checkbox
                  className="real-goku-setting-item-chk real-goku-setting-item-chk-common-width"
                  key={'deliveryArea' + index}
                  type="checkbox"
                  name={'deliveryArea' + index}
                  id={'deliveryArea' + index}
                  checked={
                    oneOrderInfo?.deliveryArea?.length > 0
                      ? oneOrderInfo?.deliveryArea?.filter((i) => i.id === deliveryArea.id)?.[0]?.isUsed
                      : false
                  }
                  onChange={(e) => {
                    if (oneOrderInfo.deliveryArea) {
                      let upDeliveryArea = [...oneOrderInfo.deliveryArea];
                      let upIndex = upDeliveryArea?.findIndex((opt) => opt.id === deliveryArea.id);
                      if (upIndex >= 0 && upDeliveryArea?.[upIndex]) {
                        if (e.target.checked) {
                          upDeliveryArea[upIndex].isUsed = e.target.checked;
                        } else {
                          // チェックを外した場合、配列から削除する
                          upDeliveryArea = upDeliveryArea?.filter((i) => i.id !== deliveryArea.id);
                        }
                      } else {
                        let newDeliveryArea = prepareDefaultChkInfo(upDeliveryArea, deliveryArea);
                        if (newDeliveryArea) {
                          newDeliveryArea.isUsed = e.target.checked;
                          upDeliveryArea.push(newDeliveryArea);
                        }
                      }
                      setOneOrderInfo({
                        ...oneOrderInfo,
                        deliveryArea: upDeliveryArea,
                      });
                    }
                  }}
                >
                  {deliveryArea.name}
                </Checkbox>
                {/* 5個ごとに改行 */}
                {(index + 1) % 5 === 0 && <br />}
              </>
            ))}
          </Col>
        </Row>
        {/** メッキ処理 */}
        <Row className="real-goku-setting-item-row">
          <Col span={24}>
            <div className="real-goku-setting-item-label-div">
              <label className="real-goku-setting-item-label">メッキ処理</label>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            {plating?.map((plating, index) => (
              <>
                <Checkbox
                  className="real-goku-setting-item-chk "
                  style={{ marginTop: index > 0 ? 7 : 0 }}
                  key={'oneOrder_plating' + index}
                  type="checkbox"
                  name={'oneOrder_plating' + index}
                  id={'oneOrder_plating' + index}
                  checked={
                    oneOrderInfo?.platingProcess?.length > 0
                      ? oneOrderInfo?.platingProcess?.filter((i) => i.id === plating.id)?.[0]?.isUsed
                      : false
                  }
                  onChange={(e) => {
                    if (oneOrderInfo.platingProcess) {
                      let upPlatingProcess = [...oneOrderInfo.platingProcess];
                      let upIndex = upPlatingProcess?.findIndex((opt) => opt.id === plating.id);
                      if (upIndex >= 0 && upPlatingProcess?.[upIndex]) {
                        if (e.target.checked) {
                          upPlatingProcess[upIndex].isUsed = e.target.checked;
                        } else {
                          // チェックを外した場合、配列から削除する
                          upPlatingProcess = upPlatingProcess?.filter((i) => i.id !== plating.id);
                        }
                      } else {
                        let newPlatingProcess = prepareDefaultChkInfo(upPlatingProcess, plating);
                        if (newPlatingProcess) {
                          newPlatingProcess.isUsed = e.target.checked;
                          upPlatingProcess.push(newPlatingProcess);
                        }
                      }
                      setOneOrderInfo({
                        ...oneOrderInfo,
                        platingProcess: upPlatingProcess,
                      });
                    }
                  }}
                >
                  {plating.name}
                </Checkbox>
                <br />
              </>
            ))}
          </Col>
        </Row>
        {/** 塗装処理 */}
        <Row className="real-goku-setting-item-row">
          <Col span={24}>
            <div className="real-goku-setting-item-label-div">
              <label className="real-goku-setting-item-label">塗装処理</label>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            {painting?.map((painting, index) => (
              <>
                <Checkbox
                  className="real-goku-setting-item-chk"
                  style={{ marginTop: index > 0 ? 7 : 0 }}
                  key={'oneOrder_painting' + index}
                  type="checkbox"
                  name={'oneOrder_painting' + index}
                  id={'oneOrder_painting' + index}
                  checked={
                    oneOrderInfo?.paintingProcess?.length > 0
                      ? oneOrderInfo?.paintingProcess?.filter((i) => i.id === painting.id)?.[0]?.isUsed
                      : false
                  }
                  onChange={(e) => {
                    if (oneOrderInfo.paintingProcess) {
                      let upPaintingProcess = [...oneOrderInfo.paintingProcess];
                      let upIndex = upPaintingProcess?.findIndex((opt) => opt.id === painting.id);
                      if (upIndex >= 0 && upPaintingProcess?.[upIndex]) {
                        if (e.target.checked) {
                          upPaintingProcess[upIndex].isUsed = e.target.checked;
                        } else {
                          // チェックを外した場合、配列から削除する
                          upPaintingProcess = upPaintingProcess?.filter((i) => i.id !== painting.id);
                        }
                      } else {
                        let newPaintingProcess = prepareDefaultChkInfo(upPaintingProcess, painting);
                        if (newPaintingProcess) {
                          newPaintingProcess.isUsed = e.target.checked;
                          upPaintingProcess.push(newPaintingProcess);
                        }
                      }
                      setOneOrderInfo({
                        ...oneOrderInfo,
                        paintingProcess: upPaintingProcess,
                      });
                    }
                  }}
                >
                  {painting.name}
                </Checkbox>
                <br />
              </>
            ))}
          </Col>
        </Row>
      </div>
    </div>
  );

  const commonSettingItem_repeatOrder = (
    <div className="real-goku-setting-div-padding">
      <div className="real-goku-setting-div">
        {/** 受注分類 */}
        <Row>
          <Col span={24}>
            <div className="real-goku-setting-item-label-div">
              <label className="real-goku-setting-item-label">受注分類</label>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            {RepeatOrderTypes?.map((item, index) => (
              <Checkbox
                className="real-goku-setting-item-chk"
                key="repeatOrder"
                type="checkbox"
                name={'repeatOrder'}
                id={'repeatOrder'}
                checked={
                  repeatOrderInfo?.orderType?.length > 0
                    ? repeatOrderInfo?.orderType?.filter((i) => i.id === item.id)?.[0]?.isUsed
                    : false
                }
                onChange={(e) => {
                  if (repeatOrderInfo.orderType) {
                    let upOrderTypeList = [...repeatOrderInfo.orderType];
                    let upIndex = upOrderTypeList?.findIndex((opt) => opt.id === item.id);
                    if (upIndex >= 0 && upOrderTypeList?.[upIndex]) {
                      if (e.target.checked) {
                        upOrderTypeList[upIndex].isUsed = e.target.checked;
                      } else {
                        // チェックを外した場合、配列から削除する
                        upOrderTypeList = upOrderTypeList?.filter((i) => i.id !== item.id);
                      }
                    } else {
                      let newOrderType = prepareDefaultChkInfo(upOrderTypeList, item);
                      if (newOrderType) {
                        newOrderType.isUsed = e.target.checked;
                        upOrderTypeList.push(newOrderType);
                      }
                    }
                    setRepeatOrderInfo({
                      ...repeatOrderInfo,
                      orderType: upOrderTypeList,
                    });
                  }
                }}
              >
                {item?.name}
              </Checkbox>
            ))}
          </Col>
        </Row>
        {/** 個数 */}
        <Row className="real-goku-setting-item-row">
          <Col span={24}>
            <div className="real-goku-setting-item-label-div">
              <label className="real-goku-setting-item-label">個数</label>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            （
            <Input
              className="real-goku-setting-item-input"
              value={repeatOrderInfo.quantityFrom}
              onChange={(e) => {
                if (/^\d*$/.test(e.target.value)) {
                  setRepeatOrderInfo({
                    ...repeatOrderInfo,
                    quantityFrom: e.target.value,
                  });
                }
              }}
            ></Input>
            ）個～（
            <Input
              className="real-goku-setting-item-input "
              value={repeatOrderInfo.quantityTo}
              onChange={(e) => {
                if (/^\d*$/.test(e.target.value)) {
                  setRepeatOrderInfo({
                    ...repeatOrderInfo,
                    quantityTo: e.target.value,
                  });
                }
              }}
            ></Input>
            ）個
          </Col>
        </Row>
        {/** 単価上限 */}
        <Row className="real-goku-setting-item-row">
          <Col span={24}>
            <div className="real-goku-setting-item-label-div">
              <label className="real-goku-setting-item-label">単価上限</label>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <div className="real-goku-setting-item-chk">
              ～
              <Input
                className="real-goku-setting-item-input"
                style={{ width: 100 }}
                value={repeatOrderInfo.maxCostUnitPrice}
                onChange={(e) => {
                  if (/^\d*$/.test(e.target.value)) {
                    setRepeatOrderInfo({
                      ...repeatOrderInfo,
                      maxCostUnitPrice: e.target.value,
                    });
                  }
                }}
              ></Input>
              円/個
            </div>
          </Col>
        </Row>
        {/** 材料・製造原価の合計の内訳に対して */}
        <Row className="real-goku-setting-item-row">
          <Col span={24}>
            <div className="real-goku-setting-item-label-div" style={{ width: 300 }}>
              <label className="real-goku-setting-item-label">材料・製造原価の合計の内訳に対して</label>
            </div>
          </Col>
        </Row>
        {/** 材料上限 */}
        <Row>
          <Col span={24}>
            <div className="real-goku-setting-item-chk">
              材料上限（
              <Input
                className="real-goku-setting-item-input"
                value={repeatOrderInfo.maxMaterialCostUnitRate}
                onChange={(e) => {
                  if (/^\d*$/.test(e.target.value)) {
                    setRepeatOrderInfo({
                      ...repeatOrderInfo,
                      maxMaterialCostUnitRate: e.target.value,
                    });
                  }
                }}
              ></Input>
              ）％になったら自動算出しない
            </div>
          </Col>
        </Row>
        {/** 溶接上限 */}
        <Row>
          <Col span={24}>
            <div className="real-goku-setting-item-chk">
              溶接上限（
              <Input
                className="real-goku-setting-item-input"
                value={repeatOrderInfo.maxWeldCostUnitRate}
                onChange={(e) => {
                  if (/^\d*$/.test(e.target.value)) {
                    setRepeatOrderInfo({
                      ...repeatOrderInfo,
                      maxWeldCostUnitRate: e.target.value,
                    });
                  }
                }}
              ></Input>
              ）％になったら自動算出しない
            </div>
          </Col>
        </Row>
        {/** 仕上上限 */}
        <Row>
          <Col span={24}>
            <div className="real-goku-setting-item-chk">
              仕上上限（
              <Input
                className="real-goku-setting-item-input"
                value={repeatOrderInfo.maxWeldFinishCostUnitRate}
                onChange={(e) => {
                  if (/^\d*$/.test(e.target.value)) {
                    setRepeatOrderInfo({
                      ...repeatOrderInfo,
                      maxWeldFinishCostUnitRate: e.target.value,
                    });
                  }
                }}
              ></Input>
              ）％になったら自動算出しない
            </div>
          </Col>
        </Row>
        {/** 材質・板厚 */}
        <Row className="real-goku-setting-item-row">
          <Col span={24}>
            <div className="real-goku-setting-item-label-div">
              <label className="real-goku-setting-item-label">材質・板厚</label>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            {materialClassData?.map((materialType, index) => (
              <div>
                <Checkbox
                  className="real-goku-setting-item-chk real-goku-setting-item-chk-date-width"
                  key={'materialTypeList' + index}
                  type="checkbox"
                  name={'materialTypeList' + index}
                  id={'materialTypeList' + index}
                  checked={
                    repeatOrderInfo?.materialTypeList?.length > 0
                      ? repeatOrderInfo?.materialTypeList?.filter((i) => i.materialTypeId === materialType.id)?.[0]
                          ?.isUsed
                      : false
                  }
                  onChange={(e) => {
                    let upMaterialTypeList = [...repeatOrderInfo.materialTypeList];
                    let upIndex = upMaterialTypeList?.findIndex((opt) => opt.materialTypeId === materialType.id);
                    if (upIndex >= 0 && upMaterialTypeList?.[upIndex]) {
                      if (e.target.checked) {
                        upMaterialTypeList[upIndex].isUsed = e.target.checked;
                      } else {
                        // チェックを外した場合、配列から削除する
                        upMaterialTypeList = upMaterialTypeList?.filter((i) => i.materialTypeId !== materialType.id);
                      }
                    } else {
                      let newMaterialType = prepareDefaultChkInfoMaterial(upMaterialTypeList, materialType);
                      if (newMaterialType) {
                        newMaterialType.isUsed = e.target.checked;
                        upMaterialTypeList.push(newMaterialType);
                      }
                    }
                    setRepeatOrderInfo({
                      ...repeatOrderInfo,
                      materialTypeList: upMaterialTypeList,
                    });
                  }}
                >
                  {materialType.name}
                </Checkbox>
                <label className="real-goku-setting-item-label">（</label>
                <Input
                  disabled={
                    repeatOrderInfo?.materialTypeList?.length > 0
                      ? repeatOrderInfo?.materialTypeList?.filter((i) => i.materialTypeId === materialType.id)?.[0]
                          ?.isUsed
                        ? false
                        : true
                      : true
                  }
                  className="real-goku-setting-item-input "
                  value={
                    repeatOrderInfo?.materialTypeList?.length > 0
                      ? repeatOrderInfo?.materialTypeList?.filter((i) => i.materialTypeId === materialType.id)?.[0]
                          ?.thicknessFrom
                      : ''
                  }
                  onChange={(e) => {
                    if (/^\d*\.?\d*$/.test(e.target.value)) {
                      let upMaterialTypeList = [...repeatOrderInfo?.materialTypeList];
                      let upIndex = upMaterialTypeList?.findIndex((opt) => opt.materialTypeId === materialType.id);
                      if (upIndex >= 0 && upMaterialTypeList?.[upIndex]) {
                        upMaterialTypeList[upIndex].thicknessFrom = e.target.value;
                      }
                      setRepeatOrderInfo({
                        ...repeatOrderInfo,
                        materialTypeList: upMaterialTypeList,
                      });
                    }
                  }}
                ></Input>
                <label className="real-goku-setting-item-label">）mm～（</label>
                <Input
                  disabled={
                    repeatOrderInfo?.materialTypeList?.length > 0
                      ? repeatOrderInfo?.materialTypeList?.filter((i) => i.materialTypeId === materialType.id)?.[0]
                          ?.isUsed
                        ? false
                        : true
                      : true
                  }
                  className="real-goku-setting-item-input "
                  value={
                    repeatOrderInfo?.materialTypeList?.length > 0
                      ? repeatOrderInfo?.materialTypeList?.filter((i) => i.materialTypeId === materialType.id)?.[0]
                          ?.thicknessTo
                      : ''
                  }
                  onChange={(e) => {
                    if (/^\d*\.?\d*$/.test(e.target.value)) {
                      let upMaterialTypeList = [...repeatOrderInfo?.materialTypeList];
                      let upIndex = upMaterialTypeList?.findIndex((opt) => opt.materialTypeId === materialType.id);
                      if (upIndex >= 0 && upMaterialTypeList?.[upIndex]) {
                        upMaterialTypeList[upIndex].thicknessTo = e.target.value;
                      }
                      setRepeatOrderInfo({
                        ...repeatOrderInfo,
                        materialTypeList: upMaterialTypeList,
                      });
                    }
                  }}
                ></Input>
                <label className="real-goku-setting-item-label">）mm</label>
              </div>
            ))}
          </Col>
        </Row>
        {/** 公差 */}
        <Row className="real-goku-setting-item-row">
          <Col span={24}>
            <div className="real-goku-setting-item-label-div">
              <label className="real-goku-setting-item-label">公差</label>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <div>
              {toleranceCoeffData?.map((item, index) => (
                <>
                  <Checkbox
                    className="real-goku-setting-item-chk real-goku-setting-item-chk-date-width"
                    key={'diff' + index}
                    type="checkbox"
                    name={'diff' + index}
                    id={'diff' + index}
                    checked={
                      repeatOrderInfo?.diff?.length > 0
                        ? repeatOrderInfo?.diff?.filter((i) => i.id === item.id)?.[0]?.isUsed
                        : false
                    }
                    onChange={(e) => {
                      if (repeatOrderInfo.diff) {
                        let upDiff = [...repeatOrderInfo.diff];
                        let upIndex = upDiff?.findIndex((opt) => opt.id === item.id);
                        if (upIndex >= 0 && upDiff?.[upIndex]) {
                          if (e.target.checked) {
                            upDiff[upIndex].isUsed = e.target.checked;
                          } else {
                            // チェックを外した場合、配列から削除する
                            upDiff = upDiff?.filter((i) => i.id !== item.id);
                          }
                        } else {
                          let newDiff = prepareDefaultChkInfo(upDiff, item);
                          if (newDiff) {
                            newDiff.isUsed = e.target.checked;
                            upDiff.push(newDiff);
                          }
                        }
                        setRepeatOrderInfo({
                          ...repeatOrderInfo,
                          diff: upDiff,
                        });
                      }
                    }}
                  >
                    {item.name}
                  </Checkbox>
                  {/* 4個ごとに改行 */}
                  {(index + 1) % 4 === 0 && <br />}
                </>
              ))}
            </div>
          </Col>
        </Row>
        {/** 仕上 */}
        <Row className="real-goku-setting-item-row">
          <Col span={24}>
            <div className="real-goku-setting-item-label-div">
              <label className="real-goku-setting-item-label">仕上</label>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            {weldFinishLevelCoeffData?.map((weldFinish, index) => (
              <>
                <Checkbox
                  className="real-goku-setting-item-chk real-goku-setting-item-chk-date-width"
                  key={'weldFinish' + index}
                  type="checkbox"
                  name={'weldFinish' + index}
                  id={'weldFinish' + index}
                  checked={
                    repeatOrderInfo?.weldFinish?.length > 0
                      ? repeatOrderInfo?.weldFinish?.filter((i) => i.id === weldFinish.id)?.[0]?.isUsed
                      : false
                  }
                  onChange={(e) => {
                    if (repeatOrderInfo.weldFinish) {
                      let upWeldFinish = [...repeatOrderInfo.weldFinish];
                      let upIndex = upWeldFinish?.findIndex((opt) => opt.id === weldFinish.id);
                      if (upIndex >= 0 && upWeldFinish?.[upIndex]) {
                        if (e.target.checked) {
                          upWeldFinish[upIndex].isUsed = e.target.checked;
                        } else {
                          // チェックを外した場合、配列から削除する
                          upWeldFinish = upWeldFinish?.filter((i) => i.id !== weldFinish.id);
                        }
                      } else {
                        let newWeldFinish = prepareDefaultChkInfoHyomen(upWeldFinish, weldFinish);
                        if (newWeldFinish) {
                          newWeldFinish.isUsed = e.target.checked;
                          upWeldFinish.push(newWeldFinish);
                        }
                      }
                      setRepeatOrderInfo({
                        ...repeatOrderInfo,
                        weldFinish: upWeldFinish,
                      });
                    }
                  }}
                >
                  <Typography.Text id={'typographyTxt'} ellipsis={{ tooltip: [weldFinish.name] }}>
                    {weldFinish.name}
                  </Typography.Text>
                </Checkbox>
                {/* 4個ごとに改行 */}
                {(index + 1) % 4 === 0 && <br />}
              </>
            ))}
          </Col>
        </Row>
        {/** 利用箇所 */}
        <Row className="real-goku-setting-item-row">
          <Col span={24}>
            <div className="real-goku-setting-item-label-div">
              <label className="real-goku-setting-item-label">利用箇所</label>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            {finalPurposCoeffData?.map((used, index) => (
              <Row>
                <Col span={8}>
                  <Checkbox
                    className="real-goku-setting-item-chk"
                    key={'usedPlace' + index}
                    type="checkbox"
                    name={'usedPlace' + index}
                    id={'usedPlace' + index}
                    checked={
                      repeatOrderInfo?.usedPlace?.length > 0
                        ? repeatOrderInfo?.usedPlace?.filter((i) => i.id === used.id)?.[0]?.isUsed
                        : false
                    }
                    onChange={(e) => {
                      if (repeatOrderInfo.usedPlace) {
                        let upUsedPlace = [...repeatOrderInfo.usedPlace];
                        let upIndex = upUsedPlace?.findIndex((opt) => opt.id === used.id);
                        if (upIndex >= 0 && upUsedPlace?.[upIndex]) {
                          if (e.target.checked) {
                            upUsedPlace[upIndex].isUsed = e.target.checked;
                          } else {
                            // チェックを外した場合、配列から削除する
                            upUsedPlace = upUsedPlace?.filter((i) => i.id !== used.id);
                          }
                        } else {
                          let newUsedPlace = prepareDefaultChkInfo(upUsedPlace, used, processPatternList);
                          if (newUsedPlace) {
                            newUsedPlace.isUsed = e.target.checked;
                            upUsedPlace.push(newUsedPlace);
                          }
                        }
                        setRepeatOrderInfo({
                          ...repeatOrderInfo,
                          usedPlace: upUsedPlace,
                        });
                      }
                    }}
                  >
                    {used.name}
                  </Checkbox>
                </Col>
                <Col span={6}>
                  <label>⇒引当工程パターン</label>
                </Col>
                <Col span={8}>
                  <Select
                    className="real-goku-material-type-select-pattern "
                    onChange={(e) => {
                      let upUsedPlace = [...repeatOrderInfo.usedPlace];
                      let upIndex = upUsedPlace?.findIndex((opt) => opt.id === used.id);
                      if (upIndex >= 0 && upUsedPlace?.[upIndex]) {
                        upUsedPlace[upIndex].patternId = e;
                      }
                      setRepeatOrderInfo({
                        ...repeatOrderInfo,
                        usedPlace: upUsedPlace,
                      });
                    }}
                    id={'process-pattern'}
                    name={'process-pattern'}
                    value={
                      repeatOrderInfo?.usedPlace?.filter((i) => i.id === used.id)?.[0]?.patternId !== undefined
                        ? repeatOrderInfo?.usedPlace?.filter((i) => i.id === used.id)?.[0]?.patternId
                        : processPatternList?.length > 0
                        ? processPatternList?.[0]?.id
                        : processPatternList?.length > 0
                        ? processPatternList?.[0]?.id
                        : 0
                    }
                    suffixIcon={<CaretDownFilled style={{ color: '#000000', fontSize: 20 }} />}
                  >
                    {processPatternList?.map((item, index) => (
                      <Select.Option key={index} id={'materialRef' + item.id} value={item.id}>
                        {item.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Col>
              </Row>
            ))}
          </Col>
        </Row>
        {/** 対応納期 */}
        <Row className="real-goku-setting-item-row">
          <Col span={24}>
            <div className="real-goku-setting-item-label-div">
              <label className="real-goku-setting-item-label">対応納期</label>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            {coeffDeliveryDates?.map((dates, index) => (
              <>
                <Checkbox
                  className="real-goku-setting-item-chk real-goku-setting-item-chk-date-width"
                  key={'deliveryDate' + index}
                  type="checkbox"
                  name={'deliveryDate' + index}
                  id={'deliveryDate' + index}
                  checked={
                    repeatOrderInfo?.deliveryDate?.length > 0
                      ? repeatOrderInfo?.deliveryDate?.filter((i) => i.id === dates.id)?.[0]?.isUsed
                      : false
                  }
                  onChange={(e) => {
                    if (repeatOrderInfo.deliveryDate) {
                      let upDeliveryDate = [...repeatOrderInfo.deliveryDate];
                      let upIndex = upDeliveryDate?.findIndex((opt) => opt.id === dates.id);
                      if (upIndex >= 0 && upDeliveryDate?.[upIndex]) {
                        if (e.target.checked) {
                          upDeliveryDate[upIndex].isUsed = e.target.checked;
                        } else {
                          // チェックを外した場合、配列から削除する
                          upDeliveryDate = upDeliveryDate?.filter((i) => i.id !== dates.id);
                        }
                      } else {
                        let newDeliveryDate = prepareDefaultChkInfo(upDeliveryDate, dates);
                        if (newDeliveryDate) {
                          newDeliveryDate.isUsed = e.target.checked;
                          upDeliveryDate.push(newDeliveryDate);
                        }
                      }
                      setRepeatOrderInfo({
                        ...repeatOrderInfo,
                        deliveryDate: upDeliveryDate,
                      });
                    }
                  }}
                >
                  {dates.name}
                </Checkbox>
                {/* 4個ごとに改行 */}
                {(index + 1) % 4 === 0 && <br />}
              </>
            ))}
          </Col>
        </Row>
        {/** 溶接部品点数 */}
        <Row className="real-goku-setting-item-row">
          <Col span={24}>
            <div className="real-goku-setting-item-label-div">
              <label className="real-goku-setting-item-label">溶接部品点数</label>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            {WeldPartCount?.map((partCount, index) => (
              <>
                <Checkbox
                  className="real-goku-setting-item-chk real-goku-setting-item-chk-date-width"
                  key={'partCount' + index}
                  type="checkbox"
                  name={'partCount' + index}
                  id={'partCount' + index}
                  checked={
                    repeatOrderInfo?.weldPartCount?.length > 0
                      ? repeatOrderInfo?.weldPartCount?.filter((i) => i.id === partCount.id)?.[0]?.isUsed
                      : false
                  }
                  onChange={(e) => {
                    if (repeatOrderInfo.weldPartCount) {
                      let upWeldPartCount = [...repeatOrderInfo.weldPartCount];
                      let upIndex = upWeldPartCount?.findIndex((opt) => opt.id === partCount.id);
                      if (upIndex >= 0 && upWeldPartCount?.[upIndex]) {
                        if (e.target.checked) {
                          upWeldPartCount[upIndex].isUsed = e.target.checked;
                        } else {
                          // チェックを外した場合、配列から削除する
                          upWeldPartCount = upWeldPartCount?.filter((i) => i.id !== partCount.id);
                        }
                      } else {
                        let newWeldPartCount = prepareDefaultChkInfo(upWeldPartCount, partCount);
                        if (newWeldPartCount) {
                          newWeldPartCount.isUsed = e.target.checked;
                          upWeldPartCount.push(newWeldPartCount);
                        }
                      }
                      setRepeatOrderInfo({
                        ...repeatOrderInfo,
                        weldPartCount: upWeldPartCount,
                      });
                    }
                  }}
                >
                  {partCount.name}
                </Checkbox>
                {/* 4個ごとに改行 */}
                {(index + 1) % 4 === 0 && <br />}
              </>
            ))}
          </Col>
        </Row>
        {/** 取付部品 */}
        <Row className="real-goku-setting-item-row">
          <Col span={24}>
            <div className="real-goku-setting-item-label-div">
              <label className="real-goku-setting-item-label">取付部品</label>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            {InstallationParts?.map((installPart, index) => (
              <>
                <Checkbox
                  className="real-goku-setting-item-chk"
                  key={'installPart' + index}
                  type="checkbox"
                  name={'installPart' + index}
                  id={'installPart' + index}
                  checked={
                    repeatOrderInfo?.installationParts?.length > 0
                      ? repeatOrderInfo?.installationParts?.filter((i) => i.id === installPart.id)?.[0]?.isUsed
                      : false
                  }
                  onChange={(e) => {
                    if (repeatOrderInfo.installationParts) {
                      let upInstallationParts = [...repeatOrderInfo.installationParts];
                      let upIndex = upInstallationParts?.findIndex((opt) => opt.id === installPart.id);
                      if (upIndex >= 0 && upInstallationParts?.[upIndex]) {
                        if (e.target.checked) {
                          upInstallationParts[upIndex].isUsed = e.target.checked;
                        } else {
                          // チェックを外した場合、配列から削除する
                          upInstallationParts = upInstallationParts?.filter((i) => i.id !== installPart.id);
                        }
                      } else {
                        let newInstallationParts = prepareDefaultChkInfoInstallationParts(
                          upInstallationParts,
                          installPart
                        );
                        if (newInstallationParts) {
                          newInstallationParts.isUsed = e.target.checked;
                          upInstallationParts.push(newInstallationParts);
                        }
                      }
                      setRepeatOrderInfo({
                        ...repeatOrderInfo,
                        installationParts: upInstallationParts,
                      });
                    }
                  }}
                >
                  {installPart.name}
                </Checkbox>
              </>
            ))}
            <br />
            {materialClassData?.map((material, index) => (
              <div style={{ marginLeft: 10 }}>
                <Checkbox
                  className="real-goku-setting-item-chk real-goku-setting-item-chk-date-width"
                  key={'installationPartsMaterials' + index}
                  type="checkbox"
                  name={'installationPartsMaterials' + index}
                  id={'installationPartsMaterials' + index}
                  checked={
                    repeatOrderInfo?.installationPartsMaterials?.length > 0
                      ? repeatOrderInfo?.installationPartsMaterials?.filter(
                          (i) => i.materialTypeId === material.id
                        )?.[0]?.isUsed
                      : false
                  }
                  onChange={(e) => {
                    if (repeatOrderInfo.installationPartsMaterials) {
                      let upInstallationPartsMaterials = [...repeatOrderInfo.installationPartsMaterials];
                      let upIndex = upInstallationPartsMaterials?.findIndex(
                        (opt) => opt.materialTypeId === material.id
                      );
                      if (upIndex >= 0 && upInstallationPartsMaterials[upIndex]) {
                        if (e.target.checked) {
                          upInstallationPartsMaterials[upIndex].isUsed = e.target.checked;
                        } else {
                          // チェックを外した場合、配列から削除する
                          upInstallationPartsMaterials = upInstallationPartsMaterials?.filter(
                            (i) => i.materialTypeId !== material.id
                          );
                        }
                      } else {
                        let newMaterialType = prepareDefaultChkInfoMaterialAmt(upInstallationPartsMaterials, material);
                        if (newMaterialType) {
                          newMaterialType.isUsed = e.target.checked;
                          upInstallationPartsMaterials.push(newMaterialType);
                        }
                      }
                      setRepeatOrderInfo({
                        ...repeatOrderInfo,
                        installationPartsMaterials: upInstallationPartsMaterials,
                      });
                    }
                  }}
                >
                  {material.name}
                </Checkbox>
                <label className="real-goku-setting-item-label">（</label>
                <Input
                  disabled={
                    repeatOrderInfo.installationPartsMaterials?.length > 0
                      ? repeatOrderInfo.installationPartsMaterials?.filter(
                          (opt) => opt.materialTypeId === material.id
                        )?.[0]?.isUsed
                        ? false
                        : true
                      : true
                  }
                  className="real-goku-setting-item-input "
                  style={{ width: 100 }}
                  value={
                    repeatOrderInfo.installationPartsMaterials?.length > 0
                      ? repeatOrderInfo.installationPartsMaterials?.filter(
                          (opt) => opt.materialTypeId === material.id
                        )?.[0]?.amt
                      : ''
                  }
                  onChange={(e) => {
                    if (/^\d*\.?\d*$/.test(e.target.value)) {
                      if (repeatOrderInfo.installationPartsMaterials) {
                        let upInstallationPartsMaterials = [...repeatOrderInfo.installationPartsMaterials];
                        let upIndex = upInstallationPartsMaterials?.findIndex(
                          (opt) => opt.materialTypeId === material.id
                        );
                        if (
                          upIndex >= 0 &&
                          upInstallationPartsMaterials[upIndex] &&
                          upInstallationPartsMaterials[upIndex].isUsed
                        ) {
                          upInstallationPartsMaterials[upIndex].amt = e.target.value;
                        }
                        setRepeatOrderInfo({
                          ...repeatOrderInfo,
                          installationPartsMaterials: upInstallationPartsMaterials,
                        });
                      }
                    }
                  }}
                ></Input>
                <label className="real-goku-setting-item-label">）円</label>
              </div>
            ))}
          </Col>
        </Row>
        {/** タップ・成形 */}
        <Row className="real-goku-setting-item-row">
          <Col span={24}>
            <div className="real-goku-setting-item-label-div">
              <label className="real-goku-setting-item-label">タップ・成形</label>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            {TapForm?.map((tap, index) => (
              <Checkbox
                className="real-goku-setting-item-chk real-goku-setting-item-chk-common-width"
                key={'tap' + index}
                type="checkbox"
                name={'tap' + index}
                id={'tap' + index}
                checked={
                  repeatOrderInfo?.tapForm?.length > 0
                    ? repeatOrderInfo?.tapForm?.filter((i) => i.id === tap.id)?.[0]?.isUsed
                    : false
                }
                onChange={(e) => {
                  if (repeatOrderInfo.tapForm) {
                    let upTapForm = [...repeatOrderInfo.tapForm];
                    let upIndex = upTapForm?.findIndex((opt) => opt.id === tap.id);
                    if (upIndex >= 0 && upTapForm?.[upIndex]) {
                      if (e.target.checked) {
                        upTapForm[upIndex].isUsed = e.target.checked;
                      } else {
                        // チェックを外した場合、配列から削除する
                        upTapForm = upTapForm?.filter((i) => i.id !== tap.id);
                      }
                    } else {
                      let newTapForm = prepareDefaultChkInfo(upTapForm, tap);
                      if (newTapForm) {
                        newTapForm.isUsed = e.target.checked;
                        upTapForm.push(newTapForm);
                      }
                    }
                    setRepeatOrderInfo({
                      ...repeatOrderInfo,
                      tapForm: upTapForm,
                    });
                  }
                }}
              >
                {tap.name}
              </Checkbox>
            ))}
          </Col>
        </Row>
        {/** 最大曲げ長さ */}
        <Row className="real-goku-setting-item-row">
          <Col span={24}>
            <div className="real-goku-setting-item-label-div">
              <label className="real-goku-setting-item-label">最大曲げ長さ</label>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            {MaxBendingLen?.map((bending, index) => (
              <>
                <Checkbox
                  className="real-goku-setting-item-chk real-goku-setting-item-chk-common-width"
                  key={'bending' + index}
                  type="checkbox"
                  name={'bending' + index}
                  id={'bending' + index}
                  checked={
                    repeatOrderInfo?.maxBendingLen?.length > 0
                      ? repeatOrderInfo?.maxBendingLen?.filter((i) => i.id === bending.id)?.[0]?.isUsed
                      : false
                  }
                  onChange={(e) => {
                    if (repeatOrderInfo.maxBendingLen) {
                      let upMaxBendingLen = [...repeatOrderInfo.maxBendingLen];
                      let upIndex = upMaxBendingLen?.findIndex((opt) => opt.id === bending.id);
                      if (upIndex >= 0 && upMaxBendingLen?.[upIndex]) {
                        if (e.target.checked) {
                          upMaxBendingLen[upIndex].isUsed = e.target.checked;
                        } else {
                          // チェックを外した場合、配列から削除する
                          upMaxBendingLen = upMaxBendingLen?.filter((i) => i.id !== bending.id);
                        }
                      } else {
                        let newMaxBendingLen = prepareDefaultChkInfo(upMaxBendingLen, bending);
                        if (newMaxBendingLen) {
                          newMaxBendingLen.isUsed = e.target.checked;
                          upMaxBendingLen.push(newMaxBendingLen);
                        }
                      }
                      setRepeatOrderInfo({
                        ...repeatOrderInfo,
                        maxBendingLen: upMaxBendingLen,
                      });
                    }
                  }}
                >
                  {bending.name}
                </Checkbox>
                {/* 4個ごとに改行 */}
                {(index + 1) % 5 === 0 && <br />}
              </>
            ))}
          </Col>
        </Row>
        {/** 最大サイズ */}
        <Row className="real-goku-setting-item-row">
          <Col span={24}>
            <div className="real-goku-setting-item-label-div">
              <label className="real-goku-setting-item-label">最大サイズ</label>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <div style={{ marginLeft: 15 }}>
              X
              <Input
                className="real-goku-setting-item-input"
                value={repeatOrderInfo.maxX}
                onChange={(e) => {
                  if (/^\d*\.?\d*$/.test(e.target.value)) {
                    setRepeatOrderInfo({
                      ...repeatOrderInfo,
                      maxX: e.target.value,
                    });
                  }
                }}
              ></Input>
              ）mm Y（
              <Input
                className="real-goku-setting-item-input"
                value={repeatOrderInfo.maxY}
                onChange={(e) => {
                  if (/^\d*\.?\d*$/.test(e.target.value)) {
                    setRepeatOrderInfo({
                      ...repeatOrderInfo,
                      maxY: e.target.value,
                    });
                  }
                }}
              ></Input>
              ）mm Z（
              <Input
                className="real-goku-setting-item-input"
                value={repeatOrderInfo.maxZ}
                onChange={(e) => {
                  if (repeatOrderInfo.maxZ != e.target.value) {
                    setRepeatOrderInfo({
                      ...repeatOrderInfo,
                      maxZ: e.target.value,
                    });
                  }
                }}
              ></Input>
              ）mm
            </div>
          </Col>
        </Row>
        {/** 納品可能エリア */}
        <Row className="real-goku-setting-item-row">
          <Col span={24}>
            <div className="real-goku-setting-item-label-div">
              <label className="real-goku-setting-item-label">納品可能エリア</label>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            {DeliveryArea?.map((deliveryArea, index) => (
              <>
                <Checkbox
                  className="real-goku-setting-item-chk real-goku-setting-item-chk-common-width"
                  key={'deliveryArea' + index}
                  type="checkbox"
                  name={'deliveryArea' + index}
                  id={'deliveryArea' + index}
                  checked={
                    repeatOrderInfo?.deliveryArea?.length > 0
                      ? repeatOrderInfo?.deliveryArea?.filter((i) => i.id === deliveryArea.id)?.[0]?.isUsed
                      : false
                  }
                  onChange={(e) => {
                    if (repeatOrderInfo.deliveryArea) {
                      let upDeliveryArea = [...repeatOrderInfo.deliveryArea];
                      let upIndex = upDeliveryArea?.findIndex((opt) => opt.id === deliveryArea.id);
                      if (upIndex >= 0 && upDeliveryArea?.[upIndex]) {
                        if (e.target.checked) {
                          upDeliveryArea[upIndex].isUsed = e.target.checked;
                        } else {
                          // チェックを外した場合、配列から削除する
                          upDeliveryArea = upDeliveryArea?.filter((i) => i.id !== deliveryArea.id);
                        }
                      } else {
                        let newDeliveryArea = prepareDefaultChkInfo(upDeliveryArea, deliveryArea);
                        if (newDeliveryArea) {
                          newDeliveryArea.isUsed = e.target.checked;
                          upDeliveryArea.push(newDeliveryArea);
                        }
                      }
                      setRepeatOrderInfo({
                        ...repeatOrderInfo,
                        deliveryArea: upDeliveryArea,
                      });
                    }
                  }}
                >
                  {deliveryArea.name}
                </Checkbox>
                {/* 5個ごとに改行 */}
                {(index + 1) % 5 === 0 && <br />}
              </>
            ))}
          </Col>
        </Row>
        {/** メッキ処理 */}
        <Row className="real-goku-setting-item-row">
          <Col span={24}>
            <div className="real-goku-setting-item-label-div">
              <label className="real-goku-setting-item-label">メッキ処理</label>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            {plating?.map((plating, index) => (
              <>
                <Checkbox
                  className="real-goku-setting-item-chk "
                  style={{ marginTop: index > 0 ? 7 : 0 }}
                  key={'repeatOrder_plating' + index}
                  type="checkbox"
                  name={'repeatOrder_plating' + index}
                  id={'repeatOrder_plating' + index}
                  checked={
                    repeatOrderInfo?.platingProcess?.length > 0
                      ? repeatOrderInfo?.platingProcess?.filter((i) => i.id === plating.id)?.[0]?.isUsed
                      : false
                  }
                  onChange={(e) => {
                    if (repeatOrderInfo.platingProcess) {
                      let upPlatingProcess = [...repeatOrderInfo.platingProcess];
                      let upIndex = upPlatingProcess?.findIndex((opt) => opt.id === plating.id);
                      if (upIndex >= 0 && upPlatingProcess?.[upIndex]) {
                        if (e.target.checked) {
                          upPlatingProcess[upIndex].isUsed = e.target.checked;
                        } else {
                          // チェックを外した場合、配列から削除する
                          upPlatingProcess = upPlatingProcess?.filter((i) => i.id !== plating.id);
                        }
                      } else {
                        let newPlatingProcess = prepareDefaultChkInfo(upPlatingProcess, plating);
                        if (newPlatingProcess) {
                          newPlatingProcess.isUsed = e.target.checked;
                          upPlatingProcess.push(newPlatingProcess);
                        }
                      }
                      setRepeatOrderInfo({
                        ...repeatOrderInfo,
                        platingProcess: upPlatingProcess,
                      });
                    }
                  }}
                >
                  {plating.name}
                </Checkbox>
                <br />
              </>
            ))}
          </Col>
        </Row>
        {/** 塗装処理 */}
        <Row className="real-goku-setting-item-row">
          <Col span={24}>
            <div className="real-goku-setting-item-label-div">
              <label className="real-goku-setting-item-label">塗装処理</label>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            {painting?.map((painting, index) => (
              <>
                <Checkbox
                  className="real-goku-setting-item-chk"
                  style={{ marginTop: index > 0 ? 7 : 0 }}
                  key={'repeatOrder_painting' + index}
                  type="checkbox"
                  name={'repeatOrder_painting' + index}
                  id={'repeatOrder_painting' + index}
                  checked={
                    repeatOrderInfo?.paintingProcess?.length > 0
                      ? repeatOrderInfo?.paintingProcess?.filter((i) => i.id === painting.id)?.[0]?.isUsed
                      : false
                  }
                  onChange={(e) => {
                    if (repeatOrderInfo.paintingProcess) {
                      let upPaintingProcess = [...repeatOrderInfo.paintingProcess];
                      let upIndex = upPaintingProcess?.findIndex((opt) => opt.id === painting.id);
                      if (upIndex >= 0 && upPaintingProcess?.[upIndex]) {
                        if (e.target.checked) {
                          upPaintingProcess[upIndex].isUsed = e.target.checked;
                        } else {
                          // チェックを外した場合、配列から削除する
                          upPaintingProcess = upPaintingProcess?.filter((i) => i.id !== painting.id);
                        }
                      } else {
                        let newPaintingProcess = prepareDefaultChkInfo(upPaintingProcess, painting);
                        if (newPaintingProcess) {
                          newPaintingProcess.isUsed = e.target.checked;
                          upPaintingProcess.push(newPaintingProcess);
                        }
                      }
                      setRepeatOrderInfo({
                        ...repeatOrderInfo,
                        paintingProcess: upPaintingProcess,
                      });
                    }
                  }}
                >
                  {painting.name}
                </Checkbox>
                <br />
              </>
            ))}
          </Col>
        </Row>
      </div>
    </div>
  );

  const confirmOk = async () => {
    settingOk();
  };

  const realGokuSettingContent = (
    <Spin spinning={openRealGokuSettingLoading} tip="Loading..." size="large">
      <div>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={24} md={12} lg={12}>
            <Row>
              <Col span={24}>
                <label className="real-goku-setting-item-title">単発対応設定項目</label>
                <Button
                  className="copy-btn"
                  onClick={(e) => {
                    let copyRepeatInfo = JSON.parse(JSON.stringify(repeatOrderInfo));
                    let oldOrderType = JSON.parse(JSON.stringify(oneOrderInfo?.orderType));
                    // 単発の設定を保持する
                    let oldOneOrderInfo = JSON.parse(JSON.stringify(oneOrderInfo));
                    if (copyRepeatInfo) {
                      copyRepeatInfo.orderType = oldOrderType;
                      setOneOrderInfo(copyRepeatInfo);
                      setOldOneOrderInfo(oldOneOrderInfo);
                    }
                  }}
                >
                  リピートの設定を単発に反映
                </Button>
                <Button
                  className="copy-btn"
                  onClick={(e) => {
                    // 保持した単発設定を戻す
                    let oneOrderInfo = JSON.parse(JSON.stringify(oldOneOrderInfo));
                    let oldOrderType = JSON.parse(JSON.stringify(oneOrderInfo?.orderType));
                    if (oneOrderInfo) {
                      oneOrderInfo.orderType = oldOrderType;
                      setOneOrderInfo(oneOrderInfo);
                    }
                  }}
                >
                  単発設定前の状態に戻す
                </Button>
              </Col>
            </Row>
            {commonSettingItem_oneOrder}
          </Col>
          <Col xs={24} sm={24} md={12} lg={12}>
            <Row>
              <Col span={24}>
                <label className="real-goku-setting-item-title">リピート対応設定項目</label>
                <Button
                  className="copy-btn"
                  onClick={(e) => {
                    let copyOneOrderInfo = JSON.parse(JSON.stringify(oneOrderInfo));
                    let oldOrderType = JSON.parse(JSON.stringify(repeatOrderInfo?.orderType));
                    // リピートの設定を保持する
                    let oldRepeatOrderInfo = JSON.parse(JSON.stringify(repeatOrderInfo));
                    if (copyOneOrderInfo) {
                      copyOneOrderInfo.orderType = oldOrderType;
                      setRepeatOrderInfo(copyOneOrderInfo);
                      setOldRepeatOrderInfo(oldRepeatOrderInfo);
                    }
                  }}
                >
                  単発の設定をリピートに反映
                </Button>
                <Button
                  className="copy-btn"
                  onClick={(e) => {
                    // 保持したリピート設定を戻す
                    let repeatOrderInfo = JSON.parse(JSON.stringify(oldRepeatOrderInfo));
                    let repeatOrderType = JSON.parse(JSON.stringify(repeatOrderInfo?.orderType));
                    if (repeatOrderInfo) {
                      repeatOrderInfo.orderType = repeatOrderType;
                      setRepeatOrderInfo(repeatOrderInfo);
                    }
                  }}
                >
                  リピート設定前の状態に戻す
                </Button>
              </Col>
            </Row>
            {commonSettingItem_repeatOrder}
          </Col>
        </Row>
      </div>
    </Spin>
  );

  return (
    <>
      <div style={{ backgroundColor: '#1063aa', display: 'flex', alignItems: 'center', height: '5vh' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'left',
            alignItems: 'center',
            width: '60%',
          }}
        >
          <Space size="large">
            <Image preview={false} width={35} src={logo} style={{ marginLeft: '5px', marginTop: '0px' }}></Image>
            {/** IQX_WEBEST-169 */}
            <h5 style={{ color: 'whitesmoke', marginLeft: '-13px', marginTop: '3px' }}>iQx-WebEstimate (1.0.87)</h5>
          </Space>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'right',
            alignItems: 'center',
            width: '39%',
          }}
        >
          <SettingOutlined
            style={{ marginLeft: '25px', fontSize: 25, color: 'white', cursor: 'pointer' }}
            onClick={(e) => openRealGokuSettingDialog()}
          />
          <Typography.Text
            onClick={(e) => openRealGokuSettingDialog()}
            ellipsis={{ tooltip: [loginUser?.companyName] }}
            style={{
              color: 'whitesmoke',
              marginLeft: '4px',
              fontSize: '14px',
              fontWeight: 'bold',
              cursor: 'pointer',
            }}
          >
            RealGoku受注設定
          </Typography.Text>
          <Image preview={false} width={32} src={company} style={{ marginLeft: '25px' }}></Image>
          <Typography.Text
            ellipsis={{ tooltip: [loginUser?.companyName] }}
            style={{
              color: 'whitesmoke',
              marginLeft: '28px',
              fontSize: '14px',
              marginRight: '20px',
              fontWeight: 'bold',
            }}
          >
            {loginUser?.companyName}
          </Typography.Text>
          <div style={{ display: 'flex', justifyContent: 'left', alignItems: 'center' }}>
            <Image preview={false} width={24} src={user}></Image>
            <Typography.Text
              ellipsis={{ tooltip: [loginUser?.userName] }}
              style={{
                color: 'whitesmoke',
                marginLeft: '10px',
                fontSize: '14px',
                marginRight: '20px',
                fontWeight: 'bold',
              }}
            >
              {loginUser?.userName}
            </Typography.Text>
          </div>
          {/* ログアウト */}
          <div
            style={{
              display: 'flex',
              justifyContent: 'left',
              alignItems: 'center',
              cursor: 'pointer',
            }}
            onClick={handleClick}
          >
            <Image preview={false} width={24} src={logout}></Image>
            <Typography.Text
              className="menu-active-hover"
              ellipsis={{ tooltip: ['ログアウト'] }}
              style={{
                color: 'whitesmoke',
                marginLeft: '10px',
                fontSize: '14px',
                marginRight: '20px',
                fontWeight: 'bold',
              }}
            >
              ログアウト
            </Typography.Text>
          </div>
          {/* 設定 */}
          <div
            // onClick={handleClick}
            style={{ display: 'flex', justifyContent: 'right', alignItems: 'center', width: '5%', marginLeft: '10px' }}
          >
            <Tooltip title="設定" placement="bottom" overlayClassName="tooltip-text">
              <Image
                preview={false}
                width={37}
                src={usersetting}
                onClick={showSetting}
                style={{ cursor: 'pointer' }}
              ></Image>
            </Tooltip>
          </div>
        </div>
      </div>
      {/* 子部品確認 */}
      {openRealGokuSetting
        ? commonResponsiveModal(
            openRealGokuSetting,
            modalTitle,
            commonFooterOK(confirmOk),
            // null,
            { height: 880 },
            1370,
            settingOk,
            settingCancel,
            realGokuSettingContent,
            'updateModalStyle',
            null,
            true
          )
        : ''}
    </>
  );
};

export default Header;
